import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  LayeredContent: {
    id: 'label_layered_content',
    defaultMessage: 'Layered content',
  },
  Items: {
    id: 'label_items',
    defaultMessage: 'Items',
  },
  Item: {
    id: 'label_item',
    defaultMessage: 'Item',
  },
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Description: {
    id: 'label_description',
    defaultMessage: 'Description',
  },
  Media: {
    id: 'label_media',
    defaultMessage: 'Media',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
});
